// Pending close timeouts keyed by modal id, so a reopen can cancel a stale
// `is-open` removal scheduled by a previous close.
const pendingCloseTimeouts = new Map();

export function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const pending = pendingCloseTimeouts.get(modalId);
    if (pending) {
        clearTimeout(pending);
        pendingCloseTimeouts.delete(modalId);
    }

    modal.classList.add('is-open');
    requestAnimationFrame(() => {
        modal.classList.add('show');
    });
}

export function closeModal(modalId = null) {
    let modal;
    if (modalId) {
        modal = document.getElementById(modalId);
    } else {
        // Close the last opened modal with .show (top-most)
        const openModals = Array.from(document.querySelectorAll('.modal.show'));
        modal = openModals.length ? openModals[openModals.length - 1] : null;
    }

    if (!modal) return;

    const id = modal.id;
    modal.classList.remove('show');

    const existing = id ? pendingCloseTimeouts.get(id) : null;
    if (existing) clearTimeout(existing);

    const timeout = setTimeout(() => {
        modal.classList.remove('is-open');
        if (id) pendingCloseTimeouts.delete(id);
    }, 300); // Match CSS transition duration

    if (id) pendingCloseTimeouts.set(id, timeout);
}
